import { render, staticRenderFns } from "./BuyXValueGiftY.vue?vue&type=template&id=0bf5342f&scoped=true&"
import script from "./BuyXValueGiftY.vue?vue&type=script&lang=js&"
export * from "./BuyXValueGiftY.vue?vue&type=script&lang=js&"
import style0 from "./BuyXValueGiftY.vue?vue&type=style&index=0&id=0bf5342f&scoped=true&lang=scss&"
import style1 from "./BuyXValueGiftY.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5342f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCol,VIcon,VRow,VSimpleTable,VTextField,VTooltip})
